export default {

	init() {
		console.log('accordion init...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		$('.accordion').each(function() {
			$(this).find('[data-accordion]').each(function(index) {
				this.setAttribute('data-accordion-key', index);
			}).on('click', function (e) {
				Accordion.toggleVisibility(this);
			});
			
		});
	},

	toggleVisibility(elem) {
		let $toggle = $(elem);
		let $target = $('#' + $toggle.attr('aria-controls'));
		let $group = $toggle.parents('[data-accordion-group]');
		let isGroup = $group.length;
		let hasImages = $toggle.parents('[data-accordion-images]').length;

		if (!$target.length) {
			return;
		}

		if (isGroup) {
			let $toggles = $group.find('[data-accordion]');
			let $panes = $group.find('.accordion-pane');

			$toggles.attr('aria-expanded', 'false')
			$panes.removeClass('is-active').attr('hidden', true);
		}

		if ($target[0].hasAttribute('hidden')) {
            $target.removeAttr('hidden').addClass('is-active');
            $toggle.attr('aria-expanded', 'true');
        } else {
            $target.removeClass('is-active').attr('hidden', true);
            $toggle.attr('aria-expanded', 'false');
        }

		// Swap current image with carousel change
		if(isGroup && hasImages) {
			let $images = $group.next('.accordion-images').find('.accordion-image-toggle');
			let key = $toggle.attr('data-accordion-key');
			let $img = $images.eq(key).length ? $images.eq(key) : $images.eq(0);

            if($images.find('video').length) {
            	$images.find('video').each(function(){
            		this.pause();
            	});
            }
            if($img.find('video').length) {
            	$img.find('video').each(function(){
            		this.play();
            	});
            }
				
			if ($img.length) {
				$images.addClass('hidden');
				$img.removeClass('hidden');
			}
		}
	}

}